module.exports = __webpack_public_path__ + "img/menu9.b182de55.png";